module.exports = __webpack_public_path__ + "img/ENTERTAINMENT.d90122cd.jpg";